import { render, staticRenderFns } from "./AddProductAreaModal.vue?vue&type=template&id=20963ee8&scoped=true"
import script from "./AddProductAreaModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddProductAreaModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20963ee8",
  null
  
)

export default component.exports